export type DiditKycModule = "poi" | "poa" | "aml" | "liveness";

export interface DiditKycModuleState {
  status?: string | null;
  isRequired?: boolean;
  sessionId?: string | null;
}

export interface DiditKycDetails {
  modules?: Partial<Record<DiditKycModule, DiditKycModuleState>> | null;
}

export interface UpdateDiditFeatureStatusRequest {
  userId: number;
  module: DiditKycModule;
  reason?: string;
}

export interface UpdateDiditFeatureStatusResponse {
  msg: string;
  data?: unknown;
  error?: string;
}

export const DIDIT_KYC_MODULES: { key: DiditKycModule; label: string }[] = [
  { key: "poi", label: "POI" },
  { key: "poa", label: "POA" },
  { key: "aml", label: "AML" },
  { key: "liveness", label: "Liveness" },
];
